import styles from "../../pages/BlogArticle.module.scss";
import { BlogMedia } from "./InstagramEmbed";
import { getSectionId } from "./articleUtils";
import { useLanguage } from "../../contexts/LanguageContext";
import { getLocalizedValue } from "../../utils/localizedContent";

export function MemoryArticleTemplate({ article }) {
  const { lang } = useLanguage();
  const points = Array.isArray(article.points) ? article.points : [];
  const intro = article.memoryIntro || {};
  const introEyebrow = getLocalizedValue(
    intro.eyebrow || "Photo & Movie",
    lang,
  );
  const introTitle = getLocalizedValue(
    intro.title || "このツアーで撮れる写真・映像",
    lang,
  );
  const introText = getLocalizedValue(
    intro.text ||
      "宮古島の海、空、SUP、ドローン映像まで。あとから見返した時に旅の空気まで思い出せるように、場所や時間帯に合わせて撮影します。",
    lang,
  );

  return (
    <div className={styles.memoryArticle}>
      <section className={styles.memoryIntro}>
        <span>{introEyebrow}</span>
        <h2>{introTitle}</h2>
        <p>{introText}</p>
      </section>

      <div className={styles.memoryGrid}>
        {points.map((point, index) => (
          <MemoryCard
            key={point.number || point.title || index}
            point={point}
            index={index}
            article={article}
          />
        ))}
      </div>
    </div>
  );
}

function MemoryCard({ point, index, article }) {
  const rows = Array.isArray(point.rows) ? point.rows : [];
  const hashtags = Array.isArray(point.hashtags) ? point.hashtags : [];

  return (
    <section id={getSectionId(index)} className={styles.memoryCard}>
      <div className={styles.memoryCardMedia}>
        <BlogMedia
          media={point.media || point.image || article.mainImage}
          alt={point.title}
        />
      </div>

      <div className={styles.memoryCardBody}>
        <div className={styles.memoryCardHeading}>
          <span>{point.number}</span>
          <div>
            {point.area && <small>{point.area}</small>}
            <h3>{point.title}</h3>
          </div>
        </div>

        {point.text && <p>{point.text}</p>}

        {rows.length > 0 && (
          <dl className={styles.memoryRows}>
            {rows.map(([label, value]) => (
              <div key={label}>
                <dt>{label}</dt>
                <dd>{value}</dd>
              </div>
            ))}
          </dl>
        )}

        {hashtags.length > 0 && (
          <div className={styles.hashtags}>
            {hashtags.map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
